// require('./bootstrap');

import Vue from "vue"

import router from './router';
import App from './layouts/App.vue';
import './component.js'
import './child-page'
import store from "./store";
import "@/plugins/axios"
import defaultMixin from "./mixins"
import './styles/index.css'
import Lightbox from 'vue-easy-lightbox'
import { MotionPlugin } from '@vueuse/motion'
import VueCardFormat from 'vue-credit-card-validation';
Vue.use(VueCardFormat);

Vue.use(MotionPlugin)

Vue.use(Lightbox)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// axios.defaults.withCredentials = false
// axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

// axios.defaults.baseURL = 'https://magnumapi.testedwebsite.com/api/';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import vuetify from './plugins/vuetify' // path to vuetify export
// import VueToastificationPlugin from "vue-toastification"; // path where

import './registerServiceWorker'
import "./plugins/vuetoastnotification";
import 'aos/dist/aos.css'
import AOS from 'aos'

// in your entrypoint



Vue.mixin(defaultMixin)

Vue.use(require('vue-pusher'), {
  api_key: process.env.VUE_APP_PUSHER_APP_KEY,
  options: {
    cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
    encrypted: false,
  }
});



store.dispatch("imagesMixerAction")


const app = new Vue({
  store,
  router,
  vuetify,
  el: '#app',
  mounted() {
    AOS.init()
  },
  render: h => h(App)
});
